import React from "react";

function Nav() {
  return (
    <aside className="app-sidebar sticky" id="sidebar">
      {/* Start::main-sidebar-header */}
      <div className="main-sidebar-header">
        <a href="/dashboards" className="header-logo">
          <img
            src="../assets/images/logo-light.png"
            alt="logo"
            className="desktop-logo"
          />
          <img
            src="../assets/images/logo-mobile.png"
            alt="logo"
            className="toggle-logo"
          />
          <img
            src="../assets/images/logo-light.png"
            alt="logo"
            className="desktop-dark"
          />
          <img
            src="../assets/images/logo-mobile.png"
            alt="logo"
            className="toggle-dark"
          />
          <img
            src="../assets/images/logo-light.png"
            alt="logo"
            className="desktop-white"
          />
          <img
            src="../assets/images/logo-mobile.png"
            alt="logo"
            className="toggle-white"
          />
        </a>
      </div>
      {/* End::main-sidebar-header */}
      {/* Start::main-sidebar */}
      <div className="main-sidebar" id="sidebar-scroll">
        {/* Start::nav */}
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <div className="slide-left" id="slide-left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#7b8191"
              width={24}
              height={24}
              viewBox="0 0 24 24"
            >
              <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
            </svg>
          </div>
          <ul className="main-menu">
            {/* Start::slide__category */}
            <li className="slide__category">
              <span className="category-name">User</span>
            </li>
            {/* Start::slide */}
            <li className="slide has-sub">
              <a href="/dashboards" className="side-menu__item">
                <i className="bx bx-layer side-menu__icon" />
                <span className="side-menu__label">Home</span>
              </a>
              <ul className="slide-menu child1"></ul>
            </li>
            {/* End::slide */}
            <li className="slide has-sub">
              <a href="javascript:void(0);" className="side-menu__item">
                <i className="bx bx-add-to-queue side-menu__icon" />
                <span className="side-menu__label">Packages</span>
                <i className="fe fe-chevron-right side-menu__angle" />
              </a>
              <ul className="slide-menu child1">
                <li className="slide">
                  <a href="agreement" className="side-menu__item">
                    Packages
                  </a>
                </li>
                <li className="slide">
                  <a href="ihistory" className="side-menu__item">
                    History
                  </a>
                </li>
              </ul>
            </li>
            <li className="slide has-sub">
              <a href="javascript:void(0);" className="side-menu__item">
                <i className="bx bx-add-to-queue side-menu__icon" />
                <span className="side-menu__label">Compounding</span>
                <i className="fe fe-chevron-right side-menu__angle" />
              </a>
              <ul className="slide-menu child1">
                <li className="slide">
                  <a href="compoundingagreement" className="side-menu__item">
                    New Compounding
                  </a>
                </li>
                <li className="slide">
                  <a href="icompound" className="side-menu__item">
                    History
                  </a>
                </li>
              </ul>
            </li>
            <li className="slide">
              <a href="connect" className="side-menu__item">
                <i className="bx bx-share-alt side-menu__icon" />
                <span className="side-menu__label">Connect Wallet</span>
              </a>
            </li>
            {/* End::slide */}
            {/* Start::slide */}
            <li className="slide has-sub">
              <a href="javascript:void(0);" className="side-menu__item">
                <i className="bx bx-credit-card side-menu__icon" />
                <span className="side-menu__label">Deposit</span>
                <i className="fe fe-chevron-right side-menu__angle" />
              </a>
              <ul className="slide-menu child1">
                <li className="slide">
                  <a href="deposit" className="side-menu__item">
                    Deposit
                  </a>
                </li>
                <li className="slide">
                  <a href="dhistory" className="side-menu__item">
                    History
                  </a>
                </li>
              </ul>
            </li>
            {/* End::slide */}
            <li className="slide has-sub">
              <a href="javascript:void(0);" className="side-menu__item">
                <i className="bx bx-dollar-circle side-menu__icon" />
                <span className="side-menu__label">Withdraw</span>
                <i className="fe fe-chevron-right side-menu__angle" />
              </a>
              <ul className="slide-menu child1">
                <li className="slide">
                  <a href="withdraw" className="side-menu__item">
                    Withdraw
                  </a>
                </li>
                <li className="slide">
                  <a href="whistory" className="side-menu__item">
                    History
                  </a>
                </li>
              </ul>
            </li>
            <li className="slide has-sub">
              <a href="javascript:void(0);" className="side-menu__item">
                <i className="bx bx-user-circle side-menu__icon" />
                <span className="side-menu__label">Profile</span>
                <i className="fe fe-chevron-right side-menu__angle" />
              </a>
              <ul className="slide-menu child1">
                <li className="slide">
                  <a href="profile" className="side-menu__item">
                    View Profile
                  </a>
                </li>
                <li className="slide">
                  <a href="profile" className="side-menu__item">
                    Manage Password
                  </a>
                </li>
                <li className="slide">
                  <a href="profile" className="side-menu__item">
                    Manage Pin
                  </a>
                </li>
                <li className="slide">
                  <a href="profile" className="side-menu__item">
                    Manage Wallet
                  </a>
                </li>
                <li className="slide">
                  <a href="kyc" className="side-menu__item">
                    KYC
                  </a>
                </li>
                <li className="slide">
                  <a href="profile" className="side-menu__item">
                    My Referrals
                  </a>
                </li>
              </ul>
            </li>
            {/* Start::slide__category */}
            <li className="slide__category">
              <span className="category-name">Account</span>
            </li>
            {/* End::slide__category */}
            {/* Start::slide */}
            <li className="slide">
              <a href="/" className="side-menu__item">
                <i className="bx bx-exit text-danger side-menu__icon" />
                <span className="side-menu__label text-danger">Logout</span>
              </a>
            </li>
            {/* End::slide */}
          </ul>
          <div className="slide-right" id="slide-right">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#7b8191"
              width={24}
              height={24}
              viewBox="0 0 24 24"
            >
              <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
            </svg>
          </div>
        </nav>
        {/* End::nav */}
      </div>
      {/* End::main-sidebar */}
    </aside>
  );
}

export default Nav;
